import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import type { NodeCfg } from '../nodes';

export const getActiveTabNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('getActiveTab'),
    controlValues: z.object({
        tabGroupId: z.string(),
    }),
});
export type GetActiveTabNodeCfgSchema = z.infer<typeof getActiveTabNodeCfgSchema>;

export const getActiveTabNodeSocketCfg = {
    controlSockets: {
        outputs: () => ({
            tabChange: 'event',
        }),
        inputs: () => ({}),
    },
    dataSockets: {
        inputs: (_cfg: NodeCfg<'getActiveTab'>) => ({}),
        outputs: (_cfg: NodeCfg<'getActiveTab'>) => {
            const ret: Record<'activeTabIndex', 'number'> = {
                activeTabIndex: 'number',
            };
            return ret;
        },
    },
} satisfies NodeSocketCfg<GetActiveTabNodeCfgSchema>;
